"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberRating = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _rounding = require("../../util/rounding");
var _index = require("../Icon/index");
var _Text = require("../Text/Text");
var _NumberRating = require("./NumberRating.styles");
var _excluded = ["value", "rounding", "fontType"];
/**
 * @since 8.4.0
 */
var NumberRating = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var value = _ref.value,
    rounding = _ref.rounding,
    fontType = _ref.fontType,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var roundedRating;

  /* istanbul ignore else */
  if (typeof rounding === 'number') {
    roundedRating = (0, _rounding.roundToDecimalPlace)(value, rounding);
  } else if (typeof rounding === 'function') {
    roundedRating = rounding(value);
  }
  return /*#__PURE__*/_react.default.createElement(_NumberRating.StyledNumberRating, (0, _extends2.default)({
    fontType: fontType
  }, rest, {
    ref: forwardedRef
  }), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    fontType: fontType
  }, roundedRating), /*#__PURE__*/_react.default.createElement(_index.IconStar, null));
});
exports.NumberRating = NumberRating;
NumberRating.displayName = 'NumberRating';
NumberRating.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The rating value. */
  value: _propTypes.default.number.isRequired,
  /**
   * Rounds the value up or down to a desired threshold.
   * If a number is provided, the default function will round to that number
   * of decimal places.
   * Or, you can provide your own rounding function that takes `value` as an arg.
   */
  rounding: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
  /**
   * Determines the font used for the label. It is encouraged to use a
   * header font type (ex: 'h4', 'bodyHeading', etc.).
   */
  fontType: _propTypes.default.oneOf(Object.values(_constants.FONT_TYPES))
} : {};
NumberRating.defaultProps = {
  rounding: 1,
  fontType: _constants.FONT_TYPES.bodySmallHeading
};